var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512.21 70.46",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#231f20;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "logo") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_2",
    "data-name": "Capa 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M0,1.17H22.46L39.1,52.79h.19L56,1.17H78.4V69.28H65V13.08h-.2L45.92,69.28H32.49L13.62,13.08l-.19.19v56H0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M92.71,1.17H134V11.92h-27.3V28.7h25V39.44h-25V58.56h27.49V69.28H92.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M200.8,14.36a46.78,46.78,0,0,0-18-3.62c-16.34,0-25.37,10.74-25.37,24.69s8.83,24.3,23.76,24.3a38.73,38.73,0,0,0,9.23-1V41H175.54V30.27h28.29V67c-7.44,2-15.15,3.51-22.68,3.51-22.66,0-38.4-11-38.4-34C142.75,13.08,157.39,0,181.15,0a71.22,71.22,0,0,1,20.57,2.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M236.31,1.17h15.84l27.48,68.11H264.09l-6-15.6H229.7l-6.12,15.6H209ZM244,14.84h-.22L233.7,42.94h20.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M291.08,11.92H271V1.17h54.16V11.92H305.12V69.28h-14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M331.79,1.17h14V58.56H373V69.28H331.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M410.51,0c22,0,34.31,14.44,34.31,35s-12.13,35.42-34.31,35.42c-22.46,0-34.3-14.54-34.3-35.42S388.24,0,410.51,0Zm0,59.73c14.33,0,19.65-12.4,19.65-24.69,0-12-5.69-24.3-19.65-24.3S390.86,23,390.86,35C390.86,47.33,396.17,59.73,410.51,59.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M454.63,1.17H471.9l26.67,50.94h.19V1.17h13.45V69.28H495.06L468.29,18.35h-.21V69.28H454.63Z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.11e36523aaecb7b4c9c12c181a49a11b.svg";
export { ForwardRef as ReactComponent };